import DigitSymbolShape from './DigitSymbolShape.vue';
import MappingLegend from './MappingLegend.vue';
export default {
  name: 'DigitSymbolReactionReview',
  components: {
    DigitSymbolShape,
    MappingLegend
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    review: {
      type: Object,
      default: null
    }
  },
  computed: {
    selectedIndex() {
      return this.review?.answer == null ? -1 : Number(this.review.answer);
    },
    resultText() {
      if (!this.review) return '本题未作答';
      return this.review.result ? '作答正确' : `作答错误，正确选项为 ${this.data.correctOptionIndex + 1}`;
    }
  },
  methods: {
    optionClass(index) {
      return {
        'is-correct': index === this.data.correctOptionIndex,
        'is-wrong': index === this.selectedIndex && index !== this.data.correctOptionIndex
      };
    }
  }
};